import React from 'react';
import man from '../../../assets/images/team/tim_regan_dropbox-2a@2x (2).png'

const ProfileCrd = ({ profileInfo }) => {
    return (
        <div className="col-12 ">

            <a target="_blank"
                className="text-decoration-none  "
                href={profileInfo?.link}>

                <p className="p-0 m-0"  >{profileInfo?.name}</p>


            </a>
        </div>

    );
};

export default ProfileCrd;